import { Button, Checkbox, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Paper, Select, TextField } from "@mui/material"
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import dayjs, { Dayjs } from "dayjs"
import { Dispatch, FC, SetStateAction, useEffect, useState } from "react"
import { AktionChildDTO } from "../../models"

interface Props {
    child: AktionChildDTO
    children: AktionChildDTO[]
    setChildren: Dispatch<SetStateAction<AktionChildDTO[]>>
    keyOfChild: number
    disableButtons: boolean
}

export const AktionsChild: FC<Props> = (props) => {

    const [value, setValue] = useState<Dayjs>(dayjs("01-01-2013"));

    const hoodieSizes = ["XS", "S", "M", "L", "XL", "XXL"];
    const shirtSizes = ["92", "98", "104", "116", "128", "140", "152", "164", "XS", "S", "M", "L", "XL", "XXL"];

    const isRealSize = (value?: string | null) =>
    value !== undefined && value !== null && value !== "" && value !== "SelectSize";

    const [showShirtSelect, setShowShirtSelect] = useState(isRealSize(props.child.shirtSize));
    const [showHoodieSelect, setShowHoodieSelect] = useState(isRealSize(props.child.hoodieSize));

    useEffect(() => {
    if (props.child.birthday !== undefined) {
        const [day, month, year] = props.child.birthday.split(".");
        setValue(dayjs(new Date(`${year}-${month}-${day}`)));
    }
    }, [props.child.birthday]);


    return (
        <Grid >
            <Paper sx={{ marginTop: '2%', marginLeft: '2.5%', padding: '15px' }} key={props.keyOfChild}>
                <h4 >Kind</h4>
                <Grid container spacing={3}>
                    <Grid item display={"block"} xs={12} sm={3}>
                        <FormControl fullWidth>
                            <InputLabel>Geschlecht *</InputLabel>
                            <Select
                                aria-required
                                labelId="gender"
                                disabled={props.disableButtons}
                                id="genderId"
                                label="Geschlecht"
                                value={props.child.gender}
                                required
                                onChange={(value) => {
                                    props.setChildren(props.children.map((child, key) => key === props.keyOfChild ? { ...child, gender: value.target.value } : child))
                                }}
                            >
                                <MenuItem value={"Männlich"}>männlich</MenuItem>
                                <MenuItem value={"Weiblich"}>weiblich</MenuItem>
                                <MenuItem value={"Divers"}>divers</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={6}>
                        <TextField
                            required
                            id="firstName"
                            label="Vorname"
                            disabled={props.disableButtons}
                            value={props.child.firstName}
                            fullWidth
                            autoComplete="firstName"
                            variant="outlined"
                            onChange={(value) => {
                                props.setChildren(props.children.map((child, key) => key === props.keyOfChild ? { ...child, firstName: value.target.value } : child))
                            }}
                        ></TextField>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            required
                            id="lastname"
                            disabled={props.disableButtons}
                            label="Nachname"
                            value={props.child.lastName}
                            fullWidth
                            autoComplete="family-name"
                            variant="outlined"
                            onChange={(value) => {
                                props.setChildren(props.children.map((child, key) => key === props.keyOfChild ? { ...child, lastName: value.target.value } : child))
                            }}
                        ></TextField>
                    </Grid>

                    <Grid item xs={12} textAlign={"left"}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DesktopDatePicker
                                label="Geburtsdatum *"
                                value={value}
                                disabled={props.disableButtons}
                                inputFormat="DD.MM.YYYY"
                                maxDate={dayjs("2015-08-02")}
                                onChange={(newValue) => {
                                    if (newValue != null) {
                                        props.setChildren(props.children.map((child, key) => key === props.keyOfChild ? { ...child, birthday: new Date(newValue!.toDate()).toLocaleDateString() } : child))
                                        setValue(newValue as Dayjs)
                                    }
                                }}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            id="allergic"
                            label="Allergien"
                            disabled={props.disableButtons}
                            value={props.child.allergica}
                            fullWidth
                            multiline
                            maxRows={4}
                            onChange={(value) => {
                                props.setChildren(props.children.map((child, key) => key === props.keyOfChild ? { ...child, allergica: value.target.value } : child))
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            id="otherRemarks"
                            label="sonstige Bemerkungen"
                            placeholder="Kann nicht schwimmen,..."
                            fullWidth
                            disabled={props.disableButtons}
                            value={props.child.otherRemarks}
                            multiline
                            maxRows={4}
                            onChange={(value) => {
                                props.setChildren(props.children.map((child, key) => key === props.keyOfChild ? { ...child, otherRemarks: value.target.value } : child))
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <p>Trifft einer der folgenden Punkte auf Ihr Kind zu?</p>
                        <Select
                            id="foodSpecials"
                            multiple
                            displayEmpty
                            fullWidth
                            disabled={props.disableButtons}
                            value={
                                props.child.intolerance
                                    ? props.child.intolerance.split(",").map((v) => v.trim())
                                    : []
                            }
                            renderValue={(selected) => {
                                if (!selected.length) {
                                    return <em>Bitte auswählen</em>;
                                }
                                return selected.join(", ");
                            }}
                            onChange={(event) => {
                                const selectedValues = Array.isArray(event.target.value)
                                    ? event.target.value
                                    : [event.target.value];

                                const joinedValues = selectedValues.join(", ");
                                props.setChildren(
                                    props.children.map((child, key) =>
                                        key === props.keyOfChild
                                            ? { ...child, intolerance: joinedValues }
                                            : child
                                    )
                                );
                            }}
                        >
                            <MenuItem disabled value="">
                                <em>Bitte auswählen</em>
                            </MenuItem>
                            <MenuItem value="Laktoseintoleranz">Laktoseintoleranz</MenuItem>
                            <MenuItem value="Zöliakie">Zöliakie (Glutenintoleranz)</MenuItem>
                            <MenuItem value="Vegan">Vegan</MenuItem>
                            <MenuItem value="Vegetarisch">Vegetarisch</MenuItem>
                            <MenuItem value="Nichts davon">Nichts davon</MenuItem>
                        </Select>
                    </Grid>
                    <Grid item xs={12}>
                        <span>
                             In diesem Jahr können im Vorfeld T-Shirts und Hoodies bestellt werden.
                        </span>
                        <br />
                        <span>
                            Preise:
                        </span>
                        <ul>
                            <li>T-Shirt: 10 €</li>
                            <li>Hoodie: 25 €</li>
                        </ul>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={showShirtSelect}
                                    disabled={props.disableButtons}
                                    onChange={(e) => {
                                        const checked = e.target.checked;
                                        setShowShirtSelect(checked);

                                        props.setChildren(
                                            props.children.map((child, key) =>
                                                key === props.keyOfChild
                                                    ? { ...child, shirtSize: checked ? "SelectSize" : "" }
                                                    : child
                                            )
                                        );
                                    }}
                                />
                            }
                            label="T-Shirt bestellen"
                        />
                    </Grid>

                    {showShirtSelect && (
                        <Grid item xs={12} sm={3}>
                            <FormControl fullWidth required error={showShirtSelect && props.child.shirtSize === ""}>
                                <Select
                                    labelId={`shirt-size-label-${props.keyOfChild}`}
                                    id={`shirt-size-${props.keyOfChild}`}
                                    value={props.child.shirtSize}
                                    label="T-Shirt Größe"
                                    disabled={props.disableButtons}
                                    onChange={(e) => {
                                        props.setChildren(
                                            props.children.map((child, key) =>
                                                key === props.keyOfChild
                                                    ? { ...child, shirtSize: e.target.value }
                                                    : child
                                            )
                                        );
                                    }}
                                >
                                    <MenuItem value="SelectSize" disabled>
                                        <em>Bitte Größe wählen</em>
                                    </MenuItem>

                                    {shirtSizes.map((size) => (
                                        <MenuItem key={size} value={size}>
                                            {size}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    )}

                    <Grid item xs={12}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={showHoodieSelect}
                                    disabled={props.disableButtons}
                                    onChange={(e) => {
                                        const checked = e.target.checked;
                                        setShowHoodieSelect(checked);
                                        props.setChildren(
                                            props.children.map((child, key) =>
                                                key === props.keyOfChild
                                                    ? { ...child, hoodieSize: checked ? "SelectSize" : "" }
                                                    : child
                                            )
                                        );
                                    }}
                                />
                            }
                            label="Hoodie bestellen"
                        />
                    </Grid>

                    {showHoodieSelect && (
                        <Grid item xs={12} sm={3}>
                            <FormControl fullWidth required error={showHoodieSelect && props.child.hoodieSize === ""}>
                                <Select
                                    labelId={`hoodie-size-label-${props.keyOfChild}`}
                                    id={`hoodie-size-${props.keyOfChild}`}
                                    value={props.child.hoodieSize}
                                    label="Hoodie Größe"
                                    disabled={props.disableButtons}
                                    onChange={(e) => {
                                        props.setChildren(
                                            props.children.map((child, key) =>
                                                key === props.keyOfChild
                                                    ? { ...child, hoodieSize: e.target.value }
                                                    : child
                                            )
                                        );
                                    }}
                                >
                                    <MenuItem value="SelectSize" disabled>
                                        <em>Bitte Größe wählen</em>
                                    </MenuItem>

                                    {hoodieSizes.map((size) => (
                                        <MenuItem key={size} value={size}>
                                            {size}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    )}
                </Grid>
                <Button variant="contained" sx={{ margin: '20px' }} onClick={() => props.setChildren(props.children.filter((child, key) => key !== props.keyOfChild))} disabled={props.disableButtons}>Kind löschen</Button>
            </Paper>
        </Grid>
    )
}
